import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CONTAINER_DATA, HighlightConfig } from './component-highlight.service';

export type AnnouncementType = 'time-saver' | 'new' | 'access' | 'special-offers';

@Component({
  selector: 'sg-component-highlight',
  templateUrl: './component-highlight.component.html',
  styleUrls: ['./component-highlight.component.scss'],
  standalone: false,
})
export class SgComponentHighlightComponent implements OnDestroy, OnInit {
  announcmentKeyToLabel: { [key in AnnouncementType]: string } = {
    'time-saver': 'Time Saver',
    new: 'New',
    access: 'All in one place',
    'special-offers': 'Special offers',
  };

  id: string;
  imageSrc: string;
  title: string;
  message: string;
  announcementType: AnnouncementType;
  hideConfirmButton: boolean;
  imagePosition: 'top' | 'bottom';
  autoAcknowledgeTimerMs: number | null;
  autoCloseTimerMs: number | null;
  showOnce: boolean;
  isTooltipStyle: boolean;
  onClose: () => void;
  cancelWithoutAcknowledging: () => void;

  private autoAcknowledgeTimerId: any;
  private autoCloseTimerId: any;

  constructor(@Inject(CONTAINER_DATA) public componentData: HighlightConfig) {
    this.setProperties(componentData);
  }

  ngOnInit(): void {
    if (this.autoAcknowledgeTimerMs !== null) {
      this.autoAcknowledgeTimerId = setTimeout(() => this.onClose(), this.autoAcknowledgeTimerMs);
    }
    if (this.autoCloseTimerMs !== null) {
      this.autoCloseTimerId = setTimeout(() => this.cancelWithoutAcknowledging(), this.autoCloseTimerMs);
    }
  }

  ngOnDestroy(): void {
    if (this.autoAcknowledgeTimerId) {
      clearTimeout(this.autoAcknowledgeTimerId);
    }
    if (this.autoCloseTimerId) {
      clearTimeout(this.autoCloseTimerId);
    }
  }

  close() {
    this.onClose();
  }

  private setProperties(componentData: HighlightConfig) {
    this.id = componentData.id;
    this.message = componentData.message;
    this.title = componentData.title;
    this.imageSrc = componentData.imageSrc;
    this.announcementType = componentData.announcementType;
    this.hideConfirmButton = componentData.hideConfirmButton || false;
    this.imagePosition = componentData.imagePosition || 'top';
    this.autoAcknowledgeTimerMs = componentData.autoAcknowledgeTimerMs ?? null;
    this.autoCloseTimerMs = componentData.autoCloseTimerMs ?? null;
    this.showOnce = componentData.showOnce || true;
    this.isTooltipStyle = componentData.isTooltipStyle || false;
    this.onClose = componentData.onClose;
    this.cancelWithoutAcknowledging = componentData.cancelWithoutAcknowledging;
  }
}
